import request from '@/utils/request'

export function updateCfg(data) {
  return request({
    url: 'api/v1/achi/updateCfg',
    method: 'post',
    data: data
  })
}

export function getCfg(data) {
  return request({
    url: 'api/v1/achi/getCfg',
    method: 'get',
    params: data
  })
}

